// const baseURL = "http://46.37.122.105:81/";

// const baseURL = "http://localhost:5001";
const baseURL = "https://erp.213.210.36.128.sslip.io";

export default baseURL;
